import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { useTranslations } from "use-intl";

import { Button } from "@lawline/ui/components/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@lawline/ui/components/tooltip";

// The server hands a secret back once, on create and on rotate, so it lives in the dialog's
// state only and never in a cached query.
export function WebhookSecret({ secret }: { secret: string }) {
	const t = useTranslations("webhooks.secret");
	const [copied, setCopied] = useState(false);

	return (
		<div className="flex flex-col gap-2">
			<p className="text-muted-foreground text-sm">{t("hint")}</p>
			<div className="bg-muted flex items-center gap-1 rounded-md border py-1.5 pr-2 pl-2">
				<code className="flex-1 font-mono text-xs leading-relaxed break-all">{secret}</code>
				<Tooltip>
					<TooltipTrigger asChild>
						<Button
							variant="ghost"
							size="icon"
							className="size-5 shrink-0"
							onClick={() => {
								void navigator.clipboard.writeText(secret);
								setCopied(true);
							}}
						>
							{copied ? <Check className="text-primary size-4" /> : <Copy className="size-4" />}
						</Button>
					</TooltipTrigger>
					<TooltipContent>{t("copyLabel")}</TooltipContent>
				</Tooltip>
			</div>
		</div>
	);
}
